import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Button
} from "reactstrap";
import { CompanyService } from "../../services/companyService";
import { Redirect } from "react-router";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";

let companyService = new CompanyService();

class EditCompany extends Component {
  constructor(props) {
    super(props);
    let creating;
    if (this.props.match.params.hasOwnProperty("id")) creating = false;
    else creating = true;
    this.state = {
      name: "",
      email: "",
      telephone: "",
      loading: !creating,
      creating: creating,
      success: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    if (!creating) this.loadData();
  }
  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }
  handleSubmit(event) {
    this.sendMessage();
    event.preventDefault();
    let self = this;
    const { name, email, telephone } = this.state;
    let req = {
      name: name,
      email: email,
      telephone: telephone
    };
    companyService
      .createOrEdit(req, this.props.match.params.id)
      .then(function(data) {
        if (!data.hasOwnProperty("error")) {
          self.setState({
            success: true
          });
          self.context.getNotificationSystem().addNotification({
            message:
              "Se ha " +
              (self.state.creating ? "creado" : "editado") +
              " exitosamente la Compañia.",
            level: "success"
          });
        } else if (data.error.details.codes.name) {
          self.context.getNotificationSystem().addNotification({
            title: "No se pudo crear la Compañia",
            message: "El Nombre ya existe",
            level: "error"
          });
        } else if (data.error.details.codes.email) {
          self.context.getNotificationSystem().addNotification({
            title: "No se pudo crear la Compañia",
            message: "El Email ya esta ocupado",
            level: "error"
          });
        }
      })
      .catch(function(error) {
        self.setState({
          success: true
        });
        console.log(error);
      });
  }
  loadData() {
    let self = this;
    companyService
      .readByID(this.props.match.params.id)
      .then(function(data) {
        if (!data.hasOwnProperty("error")) {
          data.loading = false;
          self.setState(data);
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  sendMessage(){
    this.context.getNotificationSystem().addNotification({
      message:
        "Guardando datos, por favor espere.",
      title: this.state.creating
        ? "Creación"
        : "Edición",
      level: "info"
    });
  }
  render() {
    const { creating, name, email, telephone, loading, success } = this.state;
    if (success) return <Redirect to="/companies" push={true} />;
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12" sm="12" lg="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col sm="5">
                    <CardTitle className="mb-0">
                      {creating ? "Agregando Compañia" : "Editando Compañia"}
                    </CardTitle>
                    <div className="small text-muted">{name}</div>
                  </Col>
                  <Col sm="7" className="d-sm-inline-block" />
                </Row>
              </CardHeader>
              <CardBody>
                <form onSubmit={this.handleSubmit}>
                  <Row>
                    <Col>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            Nombre
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          required
                          type="text"
                          disabled={loading}
                          id="name"
                          value={name}
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                          Email de Contacto
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          required
                          type="text"
                          disabled={loading}
                          id="email"
                          value={email}
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                          Telefono de Contacto
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          required
                          type="text"
                          disabled={loading}
                          id="telephone"
                          value={telephone}
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                      <div className="float-right">
                        {creating ? <Link
                            to={"/companies/"}
                            className="btn btn-danger"
                          >
                            Cancelar
                          </Link>
                          : <Link
                            to={"/companies/view/"+this.props.match.params.id}
                            className="btn btn-danger"
                          >
                            Cancelar
                          </Link>}

                        <span> </span>
                        <Button color="success">
                          {creating ? "Agregar" : "Guardar"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

EditCompany.contextTypes = {
  getNotificationSystem: PropTypes.func.isRequired
};

export default EditCompany;
